<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <!-- <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="pageChange"
        :total="totalNum">
      </el-pagination> -->
      <div>






        <el-table :data="productAreas" tooltip-effect="dark" style="width: 100%" border>
          <el-table-column label="共建池" align="center" prop="totalQt">
          </el-table-column>
          <el-table-column prop="tempSoloQt" label="临时铸造池" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="soloQt" label="铸造池" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="qtUnit" label="单价" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="surplusQt" label="结余池" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="withdrawRate" label="提现入共建池的费率" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="qtUnitRate" label="单价提升最大比例" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column label="操作"  align="center" width="400px">
            <template slot-scope="scope">
              <el-button size="mini" @click="editSurplusQt(scope.row)">调整结余池</el-button>
              <el-button size="mini" @click="editTotalQt(scope.row)">调整共建池</el-button>
              <el-button size="mini" @click="editRate(scope.row)">调整费率</el-button>
              <el-button size="mini" @click="editUnitRate(scope.row)">单价最高比例</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增弹出窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogValue" width="21%" :append-to-body="true" center
    	@close="cancelVerification">
    	<div class="verificationFrame">
    		<span>结余池:</span>
    		<div style="margin-left: 20px">
    			<el-input v-model="dialogValueIpt" placeholder="请输入金额" style="width: 200px" type="number"
    				class="amountInputBox"></el-input>
    		</div>
    	</div>
    	<span slot="footer" class="dialog-footer">
    		<el-button @click="cancelVerification">取 消</el-button>
    		<el-button type="primary" @click="rechargeCouponFunc">确 定</el-button>
    	</span>
    </el-dialog>
    <el-dialog title="共建池" :visible.sync="dialogTotalQtValue" width="21%" :append-to-body="true" center
    	@close="cancelVerificationTotalQt">
    	<div class="verificationFrame">
    		<span>共建池:</span>
    		<div style="margin-left: 20px">
    			<el-input v-model="totalQt" placeholder="请输入金额" style="width: 200px" type="number"
    				class="amountInputBox"></el-input>
    		</div>
    	</div>
    	<span slot="footer" class="dialog-footer">
    		<el-button @click="cancelVerificationTotalQt">取 消</el-button>
    		<el-button type="primary" @click="confirmTotalQt">确 定</el-button>
    	</span>
    </el-dialog>
    <el-dialog title="共建池费率" :visible.sync="dialogRateValue" width="21%" :append-to-body="true" center
    	@close="cancelRate">
    	<div class="verificationFrame">
    		<span>费率:</span>
    		<div style="margin-left: 20px">
    			<el-input v-model="rate" placeholder="请输入费率" style="width: 200px" type="number"
    				class="amountInputBox"></el-input>
    		</div>
    	</div>
    	<span slot="footer" class="dialog-footer">
    		<el-button @click="cancelRate">取 消</el-button>
    		<el-button type="primary" @click="editWithdrawRateConfi">确 定</el-button>
    	</span>
    </el-dialog>

    <el-dialog title="单价最高比例" :visible.sync="dialogUnitRateValue" width="21%" :append-to-body="true" center
    	@close="cancelUnitRate">
    	<div class="verificationFrame">
    		<span>单价比例:</span>
    		<div style="margin-left: 20px">
    			<el-input v-model="qtUnitRate" placeholder="请输入比例" style="width: 200px" type="number"
    				class="amountInputBox"></el-input>
    		</div>
    	</div>
    	<span slot="footer" class="dialog-footer">
    		<el-button @click="cancelUnitRate">取 消</el-button>
    		<el-button type="primary" @click="confirmQtUnit">确 定</el-button>
    	</span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    Loading
  } from 'element-ui'
  import {
    PUBLIC_URL
  } from 'api/config'
  import {
    getSystemConf,
    rechargeSurplusQt,
    editWithdrawRate,
    editTotalQt,
    editQtUnitRate
  } from 'api/request'
  import {
    loadingInstance,
    Success,
    Error
  } from 'common/js/util'
  import MSidebar from 'components/header/sidebar'
  import MHeader from 'components/header/header'
  export default {
    data() {
      return {
        productAreas: [],
        editDialogVisible: false,
        formData: {
          isEnable: "1",
          fileUrl: ''
        },
        pageNum: 1,
        totalNum: 10,
        fileList: [],
        dialogTitle: "",
        //
        dialogValue: false,
        dialogValueIpt: "",
        currentRow: {},
        dialogRateValue: false,
        rate: "",
        dialogTotalQtValue: false,
        totalQt: "",
        dialogUnitRateValue: false,
        qtUnitRate: "",
      }
    },
    components: {
      MSidebar,
      MHeader
    },
    mounted() {
    	let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
    	if (!getUserInfo) {
    		this.$router.push({
    			path: '/'
    		})
    	} else {
    		this.getList();
    	}
    },
    methods: {
      editUnitRate(row) {
        this.dialogUnitRateValue = true;
      },
      cancelUnitRate() {
        this.dialogUnitRateValue = false;
        this.qtUnitRate = "";
      },
      editRate(row) {
        this.dialogRateValue = true;
      },
      cancelRate() {
        this.dialogRateValue = false;
        this.rate = "";
      },
      editWithdrawRateConfi() {
        let param = {
        	withdrawRate: this.rate
        }
        editWithdrawRate(param).then((res) => {
        	if (res.status == 200) {
        		// 提示
        		this.$message({
        			type: "success",
        			message: res.message
        		})
        		// 重置
        		this.rate = ""
        		// 关闭
        		this.dialogRateValue = false
        		// 刷新
        		this.getList();
        	} else {
        		this.$message({
        			type: "error",
        			message: res.message
        		})
        	}
        })
      },
      confirmQtUnit() {
        let param = {
        	qtUnitRate: this.qtUnitRate
        }
        editQtUnitRate(param).then((res) => {
        	if (res.status == 200) {
        		// 提示
        		this.$message({
        			type: "success",
        			message: res.message
        		})
        		// 重置
        		this.qtUnitRate = ""
        		// 关闭
        		this.dialogUnitRateValue = false
        		// 刷新
        		this.getList();
        	} else {
        		this.$message({
        			type: "error",
        			message: res.message
        		})
        	}
        })
      },
      confirmTotalQt() {
        let param = {
        	totalQt: this.totalQt
        }
        editTotalQt(param).then((res) => {
        	if (res.status == 200) {
        		// 提示
        		this.$message({
        			type: "success",
        			message: res.message
        		})
        		// 重置
        		this.totalQt = ""
        		// 关闭
        		this.dialogTotalQtValue = false
        		// 刷新
        		this.getList();
        	} else {
        		this.$message({
        			type: "error",
        			message: res.message
        		})
        	}
        })
      },
      editSurplusQt(row) {
        this.currentRow = row;
        this.dialogValue = true;
      },
      editTotalQt(row) {
        this.currentRow = row;
        this.dialogTotalQtValue = true;
      },
      // 取消充值
      cancelVerification() {
      	this.dialogValue = false
      	this.dialogValueIpt = ""
      },
      cancelVerificationTotalQt() {
        this.dialogTotalQtValue= false;
        this.totalQt= ""
      },
			// 刷卡/现金
			rechargeCouponFunc() {
				let param = {
					surplusQt: this.dialogValueIpt
				}
				rechargeSurplusQt(param).then((res) => {
					if (res.status == 200) {
						// 提示
						this.$message({
							type: "success",
							message: res.message
						})
						// 重置
						this.dialogValueIpt = ""
						// 关闭
						this.dialogValue = false
						// 刷新
						this.getList();
					} else {
						this.$message({
							type: "error",
							message: res.message
						})
					}
				})
			},
      getList() {
        getSystemConf().then((res) => {
          console.log(res)
          if (res.status == 200) {
            this.productAreas = [];
            this.productAreas.push(res.data)
          }
        })
      },
      // 确认提交
      confirm() {
        if (this.formData.fileUrl !== undefined) {
          confirmFunc(this.formData).then((res) => {
            if (res.status === 200) {
              Success(this, res)
              this.getList()
              this.editDialogVisible = false
              this.resetFunc()
            }
          })
          return
        }
      },
      pageChange(val) {
        this.pageNum = val
        this.getList()
      },
      // 文件列表移除文件时的钩子
      handleManyRemove(file, fileList) {
        if (fileList.length == 0) {
          this.formData.fileUrl = "";
        }
      },
      uploadManyFile(param) {
        const that = this
        let form = new FormData();
        let fileObj = param.file;
        form.append("file", fileObj);
        form.append("type", 302);
        loadingInstance(Loading)
        appUploadFile(form).then((res) => {
          if (res.status == 200) {
            // 赋值
            that.assignment(res.data)
          }
        })
      },
      resetFunc() {
        this.formData = {
          isEnable: "1",
          fileUrl: undefined,
          remark: undefined,
          appVersion: undefined
        }
        // 钩子fileList
        this.fileList = []
      },
      beforeClose(done) {
        this.resetFunc()
        done()
      },
      cancel() {
        this.resetFunc()
        this.editDialogVisible = false
      },
      assignment(data) {
        this.formData.fileUrl = data
        loadingInstance(Loading).close()
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style scoped>
  .buttonFrame {
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/system/qtManage.vue